import { faExternalLinkAlt, faFileInvoiceDollar } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Modal, Space } from "antd"
import { CreateInvoiceResponse } from "../../../domain/invoicing/invoicingApi"
import SendInvoiceButton from "../SendInvoice/SendInvoiceButton"
import PayInvoiceButton from "../PayInvoice/PayInvoiceButton"

type Props = {
  isOpen: boolean
  onClose: () => void
  data: CreateInvoiceResponse | null
}

const CreationConfirmationModal = ({ isOpen, onClose, data }: Props) => {
  const isQuickBooks = data?.invoicingSystem === 'quickBooks'
  const isSynkedUP = data?.invoicingSystem === 'synkedUp'

  return <Modal
    open={isOpen}
    onCancel={() => onClose()}
    title={<Space><FontAwesomeIcon icon={faFileInvoiceDollar}/> Invoice Created</Space>}
    footer={<Space>
      <Button onClick={() => onClose()}>Close</Button>
      {isQuickBooks && <>
        <Button
          type="primary"
          onClick={() => window.open(data.qboInvoiceUrl, "_blank")}
          icon={<FontAwesomeIcon icon={faExternalLinkAlt}/>}
        >Open in QuickBooks Online</Button>
      </>}
      {isSynkedUP && <>
        <SendInvoiceButton controlsDisabled={false} invoiceId={data.invoiceId} onSendInvoice={onClose} />
        <PayInvoiceButton invoiceId={data.invoiceId} onPayInvoice={onClose} />
      </>}
    </Space>}
  >
    <span>Invoice has been generated.</span>
  </Modal>
}

export default CreationConfirmationModal